import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import CareersArchiveData from "@jsons/careerArchive.json"
import StoriesArchiveSection from "@pages/StoriesArchive/StoriesArchiveSection"
import React from "react"

type Props = {}

const storiesArchive = (props: Props): JSX.Element => {
	const Stories = getTranslatedPageData(CareersArchiveData, true, true)

	return (
		<>
			<HeadMeta meta={Stories.metaData} />

			<StoriesArchiveSection
				data={getValueOrThrow(Stories.AdvancedSideAsset?.[0])}
			/>
		</>
	)
}

export default storiesArchive
